import React from "react";
import styled, { css } from "styled-components";
import PrimaryBtn from "./Primary";

const RoundedPrimaryBtnStyle = css`
  width: 100%;
  height: 4rem;
  margin: 1rem auto 3rem;
  border-radius: 3px;
  position: relative;
  z-index: 1;
  font-size: 1.25rem;
  background-color: ${({ theme }) => theme.colors.green700};
  &:hover {
    background-color: ${({ theme }) => theme.colors.green800};
  }
  ${({ theme }) => theme.media.desktopUp`
    margin: auto 1rem;
    height: 3rem;
    width: auto;
  `}
`;

const StyledButton = styled(PrimaryBtn)`
  ${RoundedPrimaryBtnStyle};
`;

const RoundedPrimaryBtn = ({ className, children }) => (
  <StyledButton className={className}>{children}</StyledButton>
);

export default RoundedPrimaryBtn;
export { RoundedPrimaryBtnStyle };